import common from './common/ko.js';
import sample from './sample/ko.js';
import account from './account/ko.js';

export default {
    common,
    sample,
    account,
};
